import React, { useEffect, useState } from "react";
import HomePage from "./components/pages/HomePage";
//import LanguageProvider from "./components/molecules/language";

function App() {
	const [scrolling, setScrolling] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			if (window.scrollY > 50) {
				setScrolling(true);
			} else {
				setScrolling(false);
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	return (
		//<LanguageProvider>
			<div>
				<HomePage
					className={scrolling ? "navbar visible" : "navbar transparent"}
				/>
			</div>
		//</LanguageProvider>
	);
}

export default App;
